import { createImg } from '@/modules/misc/common/navbar/components/avatar.js';

export function updateProfilePicture(url) {
  const btnWrapper = document.querySelector('.ds-header__navbar__avatar__btn_img');

  if (!url && btnWrapper.dataset.initials) {
    btnWrapper.innerHTML = '';
    btnWrapper.appendChild(document.createTextNode(btnWrapper.dataset.initials));

    if (btnWrapper.dataset.background && btnWrapper.dataset.color) {
      btnWrapper.style.backgroundColor = btnWrapper.dataset.background;
      btnWrapper.style.color = btnWrapper.dataset.color;
    }
    return;
  }

  const profilePictureImg = document.getElementById('profilePicture');
  if (!profilePictureImg) {
    btnWrapper.innerHTML = '';
    btnWrapper.appendChild(createImg({
      src: url,
      className: 'header__navbar__avatar__img__img',
    }));
    return;
  }
  profilePictureImg.setAttribute('src', url);
}
